import duplicateAsTemplateIcon from 'assets/icons/icon-duplicate-template-12.svg';
import { addDays } from 'date-fns';
import { Proposal, useConfirmDuplicate, useProposals } from 'modules/proposals';
import { Settings, useConfigSelector } from 'modules/settings';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'shared/components';

interface Props {
  className: string;
  proposal: Proposal;
  btnSelector?: string;
}

export const DuplicateAsTemplateButton: React.FC<Props> = ({
  className,
  proposal,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const { isDirty, handleConfirmDuplicate } = useConfirmDuplicate();
  const { reserveProposalId, createEntityAsync } = useProposals();

  const config = useConfigSelector();

  async function onClick(e: React.MouseEvent) {
    if (isDirty && !handleConfirmDuplicate(e)) return;

    const id = await createEntityAsync(
      new Proposal({
        ...proposal,
        name: `Template of: ${proposal.name}`,
        id: reserveProposalId(),
        displayDateTime: Date.now(),
        creationDateTime: Date.now(),
        validUntilDateTime: +new Date(addDays(new Date(), 14)),
        publishStatus: 'template',
        acceptanceStatus: 'pending',
        visibility: 'public',
        ownerNotifiedDate: null,
        companyInfo: config
          ? { ...new Settings(config) }
          : proposal.companyInfo,
        vatPercentage: config?.tax?.vatPercentage || proposal.vatPercentage,
        currency: config?.defaultCurrency || proposal.currency,
        responseStatus: config?.defaultProposalResponseStatus || 'allowed',
        servicePricesVisibility:
          config?.defaultServicePricesVisibility || 'visible',
      }),
    );

    if (typeof id === 'string') {
      if (window.Cypress) {
        return;
      }

      window.open(
        formatMessage({ id: 'routes.new-proposal' }, { id }),
        '_blank',
      );
      return;
    }
  }

  return (
    <Button
      type="button"
      className={`${className} btn__icon__fill`}
      onClick={onClick}
      {...props}
    >
      <img
        src={duplicateAsTemplateIcon}
        alt="DuplicateAsTemplateIcon"
        className="btn__icon btn__icon__left"
      />
      <FormattedMessage id="buttons.template-save" />
    </Button>
  );
};
